import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trans } from 'react-i18next';
import { Button, Popup } from 'next-common-lib';
import i18n from 'i18n';
import { isIE } from 'utils/common';
import useWindowDimensions from 'utils/hook/useWindowDimension';
import { ALERT_CONFIRM_MODAL_SIZE } from 'constants/IncorporationConstants';
import * as alertActions from 'redux/ducks/common/alertDucks';

export const Alert = () => {
  const dispatch = useDispatch();
  const alert = useSelector(state => state.alert);
  const scrollY = window.scrollY;

  const closeSetScroll = () => {
    window.scrollTo(0, scrollY);
  };

  const mappingMessage = () => {
    const result = [];
    alert.message.forEach(msg => {
      if (msg) {
        result.push(typeof msg === 'object' ? <Trans i18nKey={msg.key} values={msg.value} /> : <Trans i18nKey={msg} />);
      } else {
        result.push(<Trans i18nKey="CO500" />);
      }
    });
    return result;
  };
  const windowDimension = useWindowDimensions();

  const setTopPosition = () => {
    return windowDimension.resizeHeight / 2 - ALERT_CONFIRM_MODAL_SIZE.xs.height / 2 + scrollY;
  };

  const setLeftPosition = () => {
    return windowDimension.resizeWidth / 2 - ALERT_CONFIRM_MODAL_SIZE.xs.width / 2;
  };

  return (
    <>
      {alert.isShow && (
        <Popup
          id="employee_Alert"
          top={`${setTopPosition()}px`}
          left={`${setLeftPosition()}px`}
          isShow={alert.isShow}
          isDimed={isIE() && alert.isShow ? false : alert.isShow}
          dimedClassName={isIE() ? 'transparent' : 'has-bg'}
          size="xs"
          zIndex={2500}
          isDimedOverlap
          componentType="normalPopup"
          useScroll
          closeFunction={
            alert.isDelCloseButton
              ? null
              : () => {
                  alert.callback();
                  closeSetScroll();
                  dispatch(alertActions.close());
                }
          }
          headerComponent={[
            <h1 className="popup-title" key={1}>
              {i18n.t('EM_T_NOTICE')}
            </h1>,
          ]}
          contentsComponent={mappingMessage()}
          bottomComponent={[
            <div className="btn-set al-right">
              <div className="btn-group">
                <Button
                  componentType="solid"
                  className="primary"
                  size="md"
                  label={i18n.t('EM_T_OK')}
                  onClick={() => {
                    alert.callback();
                    closeSetScroll();
                    dispatch(alertActions.close());
                  }}
                />
              </div>
            </div>,
          ]}
        />
      )}
    </>
  );
};
Alert.propTypes = {};
Alert.defaultProps = {};
export default Alert;
